import React from 'react'

import Layout from '../../../components/Layout'
import SEO from '../../../components/Seo'
import Divider from '../../../components/Divider'

import HeroSection from '../../../components/products/liveblog/HeroSection'
import RealTimeSection from '../../../components/products/liveblog/RealTimeSection'
import AdvantageSection from '../../../components/products/liveblog/AdvantageSection'

import CustomerSection from '../../../components/comoon/CustomerSection'
import FeaturesSection from '../../../components/comoon/FeaturesSection'
import AccordionSection from '../../../components/comoon/AccordionSection'
import CustomerNumbersSection from '../../../components/comoon/CustomerNumbersSection'
import TabSection from '../../../components/comoon/TabSection'
import IntegrationsSection from '../../../components/comoon/IntegrationsSection'
import AddSection from '../../../components/comoon/AddSection'
import ExploreSection from '../../../components/comoon/ExploreSection'

const LiveBlogPage = () => {
  return (
    <Layout>
      <SEO title="Live Blog" />
      <HeroSection />
      <CustomerSection />
      <FeaturesSection
        type="liveblog"
        subtype="news"
        hideIcon
        sixItems
        largeImg
        noSubtitle
        noButton
      />
      <RealTimeSection />
      <AdvantageSection />
      <CustomerNumbersSection purple borderTop marginBottom />
      <FeaturesSection type="liveblog" subtype="latest_news" fourItems />
      <TabSection type="liveblog" treeItems />
      <AccordionSection type="liveblog" subtype="data" />
      <IntegrationsSection negativeBottom />
      <AddSection liveblog center white />
      <Divider />
      <ExploreSection liveblog />
    </Layout>
  )
}

export default LiveBlogPage
